import React from "react";
import "./Skills.css";

const Skills = () => {
  return (
    <section id="skills" className="skills-section">
      <h2 className="skills-heading">Skills</h2>
      <p className="skills-intro">
        Here is an overview of the main technologies and tools I work with.
      </p>

      <div className="skills-grid">
        <div className="skills-card">
          <h3 className="skills-card-title">Programming Languages</h3>
          <ul className="skills-list">
            <li>Python</li>
            <li>Java</li>
            <li>C#</li>
            <li>JavaScript / TypeScript</li>
            <li>HTML / CSS</li>
            {/* <li>Scala</li>
            <li>OCaml</li>
            <li>Haskell</li>
            <li>Agda</li> */}
          </ul>
        </div>

        <div className="skills-card">
          <h3 className="skills-card-title">Web & Backend</h3>
          <ul className="skills-list">
            <li>React</li>
            <li>Django</li>
            {/* <li>FastAPI</li> */}
            <li>Flask</li>
            <li>Microservices</li>
            <li>REST / GraphQL / gRPC</li>
          </ul>
        </div>

        <div className="skills-card">
          <h3 className="skills-card-title">Data & AI</h3>
          <ul className="skills-list">
            <li>Pandas, NumPy</li>
            <li>PySpark</li>
            <li>Spark, Spark Structured Streaming</li>
            <li>Kafka</li>
            <li>XGBoost</li>
            <li>SQL / NoSQL</li>
          </ul>
        </div>

        <div className="skills-card">
          <h3 className="skills-card-title">Cloud & DevOps</h3>
          <ul className="skills-list">
            <li>GCP (GKE)</li>
            <li>Kubernetes, OpenStack</li>
            <li>Docker</li>
            <li>Terraform</li>
            <li>Prometheus</li>
            <li>CI/CD (GitHub / GitLab)</li>
          </ul>
        </div>

        <div className="skills-card">
          <h3 className="skills-card-title">UX & HCI</h3>
          <ul className="skills-list">
            <li>Prototyping</li>
            <li>Experience mapping</li>
            <li>VR / 3D development</li>
            <li>Unity, Blender</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Skills;